var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/language_dropdown.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import classNames from 'classnames';
import { supportsPassiveEvents } from 'detect-passive-events';
import ISO6391 from 'iso-639-1';
import { debounce } from 'lodash';
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from 'soapbox/actions/modals';
import { Input } from 'soapbox/components/ui';
import { isUserTouching } from 'soapbox/is_mobile';
const listenerOptions = supportsPassiveEvents ? {
  passive: true
} : false;
const LanguageDropdownMenu = ({
  style,
  items,
  value,
  onClose,
  onChange,
  reference
}) => {
  const [node, setNode] = useState(null);
  const list = useRef(null);
  const focusedItem = useRef(null);
  const {
    top
  } = reference.getBoundingClientRect();
  const {
    attributes,
    styles
  } = usePopper(reference, node, {
    placement: top * 2 < window.innerHeight ? 'bottom' : 'top'
  });
  const handleDocumentClick = useCallback(e => {
    if (node && !node.contains(e.target)) {
      onClose();
    }
  }, [node, onClose]);
  const handleKeyDown = e => {
    const index = Number.parseInt(e.currentTarget.getAttribute('data-index'), 10);
    let element = undefined;
    switch (e.key) {
      case 'Escape':
        onClose();
        break;
      case 'Enter':
        handleClick(e);
        break;
      case 'ArrowDown':
        element = list.current?.querySelector(`[data-index='${index + 1}']`) || list.current?.firstChild;
        break;
      case 'ArrowUp':
        element = list.current?.querySelector(`[data-index='${index - 1}']`) || list.current?.lastChild;
        break;
      case 'Tab':
        if (e.shiftKey) {
          element = list.current?.querySelector(`[data-index='${index - 1}']`) || list.current?.lastChild;
        } else {
          element = list.current?.querySelector(`[data-index='${index + 1}']`) || list.current?.firstChild;
        }
        break;
      case 'Home':
        element = list.current?.firstChild;
        break;
      case 'End':
        element = list.current?.lastChild;
        break;
    }
    if (element) {
      element.focus();
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const handleClick = e => {
    const option = items.find(it => it.value === e.currentTarget?.getAttribute('data-value'));
    e.preventDefault();
    onClose();
    onChange(option);
  };
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('touchend', handleDocumentClick, listenerOptions);
    return () => {
      document.removeEventListener('click', handleDocumentClick, false);
      document.removeEventListener('touchend', handleDocumentClick);
    };
  }, [handleDocumentClick]);
  const [currentItems, setCurrentItems] = useState(items);
  const onSearchChange = useCallback(e => {
    const search = e.target.value.toUpperCase().normalize('NFC');
    if (search.length === 0) {
      setCurrentItems(items);
      return;
    }
    setCurrentItems(items.filter(i => i.label.toUpperCase().normalize('NFC').indexOf(search) !== -1));
  }, [items]);
  const onSearchChangeDebounced = useMemo(() => {
    return debounce(onSearchChange, 500);
  }, [onSearchChange]);
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", _extends({
    className: 'absolute bg-white dark:bg-slate-900 rounded-md shadow-lg ml-10 text-sm',
    style: _objectSpread(_objectSpread({}, style), styles.popper),
    role: "listbox",
    ref: setNode
  }, attributes.popper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "p-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    onChange: onSearchChangeDebounced,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "h-[250px] overflow-y-auto",
    ref: list,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 9
    }
  }, currentItems.map((item, index) => /*#__PURE__*/React.createElement("div", {
    role: "option",
    tabIndex: 0,
    key: item.value + index,
    "data-index": index,
    "data-value": item.value,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    className: classNames('p-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-800', {
      active: item.value === value
    }),
    "aria-selected": item.value === value,
    ref: item.value === value ? focusedItem : null,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "language-dropdown__option__content",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-primary-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 17
    }
  }, item.value), "\xA0", item.label))))), document.body);
};
const ALL_OPTIONS = ISO6391.getAllCodes().map(code => ({
  value: code,
  label: ISO6391.getNativeName(code)
}));
const STORAGE_KEY = 'soapbox:language_dropdown';
function dedup(items) {
  return Array.from(new Set(items.map(i => JSON.stringify(i)))).map(i => JSON.parse(i));
}
const LanguageDropdown = ({
  onChange,
  value
}) => {
  const [node, setNode] = useState(null);
  const activeElement = useRef(null);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const buildOptions = useCallback(() => {
    const previousChoices = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return [...previousChoices, ...ALL_OPTIONS];
  }, []);
  const options = useMemo(() => buildOptions(), [buildOptions]);
  const onInternalChange = useCallback(option => {
    const previousChoices = dedup([option, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')]).slice(0, 3);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(previousChoices));
    onChange(option.value);
  }, [onChange]);
  const handleModalActionClick = useCallback(e => {
    e.preventDefault();
    const option = options[e.currentTarget.getAttribute('data-index')];
    dispatch(closeModal('ACTIONS'));
    onInternalChange(option);
  }, [options, dispatch, onInternalChange]);
  const handleToggle = React.useCallback(e => {
    e.stopPropagation();
    if (isUserTouching()) {
      if (open) dispatch(closeModal('ACTIONS'));else dispatch(openModal('ACTIONS', {
        actions: options.map(option => _objectSpread(_objectSpread({}, option), {}, {
          text: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", {
            className: "text-primary-600",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 183,
              columnNumber: 98
            }
          }, option.value), "\xA0", option.label),
          active: option.value === value
        })),
        onClick: handleModalActionClick
      }));
    } else {
      if (open) activeElement.current?.focus();
      setOpen(!open);
    }
  }, [open, dispatch, options, handleModalActionClick, value]);
  const handleMouseDown = useCallback(() => {
    if (!open) {
      activeElement.current = document.activeElement;
    }
  }, [open]);
  const handleButtonKeyDown = useCallback(e => {
    switch (e.key) {
      case ' ':
      case 'Enter':
        handleMouseDown();
        break;
    }
  }, [handleMouseDown]);
  const handleClose = useCallback(() => {
    if (open) {
      activeElement.current?.focus();
    }
    setOpen(false);
  }, [open]);
  const handleKeyDown = useCallback(e => {
    switch (e.key) {
      case 'Escape':
        handleClose();
        break;
    }
  }, [handleClose]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('language-dropdown', {
      active: open
    }),
    onKeyDown: handleKeyDown,
    ref: setNode,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('language-dropdown__value'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "text-gray-400 hover:text-gray-600 border-0 bg-transparent px-1 font-bold",
    onClick: handleToggle,
    onMouseDown: handleMouseDown,
    onKeyDown: handleButtonKeyDown,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 9
    }
  }, value)), open && /*#__PURE__*/React.createElement(LanguageDropdownMenu, {
    items: options,
    value: value,
    onClose: handleClose,
    onChange: onInternalChange,
    reference: node,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 235,
      columnNumber: 11
    }
  }));
};
export default LanguageDropdown;